var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRmasvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.17 21.47C26.02 19.15 24.12 17.31 21.74 17.22H14.79L17.13 14.91C17.46 14.61 17.48 14.1 17.18 13.78C17.03 13.62 16.81 13.52 16.59 13.52C16.39 13.52 16.2 13.6 16 13.78L12.98 16.77C12.65 17.1 12.46 17.55 12.46 18.02C12.46 18.5 12.64 18.94 12.98 19.28L16 22.26C16.16 22.41 16.36 22.49 16.57 22.49C16.78 22.49 16.99 22.41 17.14 22.27C17.29 22.12 17.38 21.92 17.38 21.7C17.38 21.48 17.3 21.28 17.15 21.14L14.81 18.83H21.68C23.12 18.83 24.36 19.9 24.57 21.32C24.78 22.89 23.67 24.34 22.1 24.54C21.97 24.56 21.85 24.56 21.72 24.56H20.25C19.81 24.56 19.45 24.92 19.45 25.36C19.45 25.8 19.81 26.16 20.25 26.16H21.72C24.19 26.16 26.2 24.16 26.2 21.69C26.2 21.61 26.2 21.54 26.2 21.46L26.17 21.47Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.51 5.6H14.73V9.21C14.73 9.65 15.09 10.01 15.53 10.01C15.97 10.01 16.33 9.65 16.33 9.21V5.6H19.49C20.67 5.6 21.63 6.56 21.63 7.74V12.15C21.63 12.59 21.99 12.95 22.43 12.95C22.87 12.95 23.23 12.59 23.23 12.15V7.74C23.23 5.68 21.55 4 19.49 4H7.74C5.68 4 4 5.68 4 7.74V20.23C4 22.29 5.68 23.97 7.74 23.97H9.94C10.38 23.97 10.74 23.61 10.74 23.17C10.74 22.73 10.38 22.37 9.94 22.37H7.74C6.56 22.37 5.6 21.41 5.6 20.23V7.74C5.6 6.56 6.56 5.6 7.74 5.6H10.9V12.26C10.9 12.7 11.26 13.06 11.7 13.06C12.14 13.06 12.5 12.7 12.5 12.26V5.6H12.51Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmasvg);
export default __webpack_public_path__ + "static/media/rmasvg.a9d8538afa3d24871a9cece45f5ff988.svg";
export { ForwardRef as ReactComponent };